import {cx} from "@emotion/css";
import {ReactComponent as SvgActivity} from "assets/svg/activity.svg";

import {designColors} from "~/ui";

import {simpleIconStyles} from "../styles";
import {commonStyles} from "../../_common/styles";
import {IIconBase} from "../../_common/types";

export const BmActivityIcon: React.FC<IIconBase> = ({id, size = "sm", color = designColors.black, className}) => {
  return <SvgActivity id={id} className={cx(simpleIconStyles(size), commonStyles.color(color), className)} />;
};
